/**
 * Label Standardization Utility
 * Cropping label to capture frame
 */

export interface CropResult {
  canvas: HTMLCanvasElement
  confidence: 'high' | 'medium' | 'low'
  method: 'center-crop' | 'scale-only'
}

/**
 * Crop to camera frame overlay (90% width, 90% height, centered with 5% margin)
 */
export function cropToCameraFrame(sourceCanvas: HTMLCanvasElement): CropResult {
  const {width: srcW, height: srcH} = sourceCanvas

  if (srcW <= 0 || srcH <= 0) {
    return {canvas: sourceCanvas, confidence: 'low', method: 'scale-only'}
  }

  // Crop to 90% of original dimensions (5% margin on each side)
  const frameWidth = srcW * 0.9
  const frameHeight = srcH * 0.9
  const frameX = srcW * 0.05 // 5% offset from left
  const frameY = srcH * 0.05 // 5% offset from top

  const outputCanvas = document.createElement('canvas')
  outputCanvas.width = frameWidth
  outputCanvas.height = frameHeight

  const ctx = outputCanvas.getContext('2d')
  if (!ctx) {
    return {canvas: sourceCanvas, confidence: 'low', method: 'scale-only'}
  }

  ctx.drawImage(
    sourceCanvas,
    frameX,
    frameY,
    frameWidth,
    frameHeight,
    0,
    0,
    frameWidth,
    frameHeight
  )

  return {canvas: outputCanvas, confidence: 'high', method: 'center-crop'}
}
